/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { JobLogResponse } from '../types/JobLog';

import type { UseResource } from '../../hooks/useResource';
import { useResource } from '../../hooks/useResource';

export type DocsImportLogsListRequest = {} | null | undefined;
export type DocsImportLogsListResponse = JobLogResponse[];

export type DocsImportLogsListQuery = {
  /**
   * ```yaml
   * in: query
   * name: date__gt
   * schema:
   *   type: string
   *   format: date-time
   * ```
   */
  date__gt?: string;

  /**
   * ```yaml
   * in: query
   * name: date__lt
   * schema:
   *   type: string
   *   format: date-time
   * ```
   */
  date__lt?: string;

  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * required: true
   * ```
   */
  id?: number;

  /**
   * ```yaml
   * in: query
   * name: level
   * schema:
   *   type: integer
   *   enum:
   *     - 1
   *     - 2
   *     - 3
   *     - 4
   *     - 5
   *     - 6
   * description: |-
   *   * `1` - Fatal
   *   * `2` - Error
   *   * `3` - Warn
   *   * `4` - Info
   *   * `5` - Debug
   *   * `6` - Trace
   * ```
   */
  level?: '1' | '2' | '3' | '4' | '5' | '6';

  /**
   * ```yaml
   * in: query
   * name: level__in
   * schema:
   *   type: array
   *   items:
   *     type: integer
   * description: Více hodnot lze oddělit čárkami.
   * explode: false
   * style: form
   * ```
   */
  level__in?: number[];
};

/**
 * GET /dmx-server/docs/{id}/import_logs/
 *
 * ```yaml
 * operationId: docs_import_logs_list
 * description: >-
 *   Slouží jako základ pro vytváření ViewSets pro zobrazení logů nad konkrétními
 *   objekty, např.
 *
 *   nad objednávkami, kontrolami.
 *
 *
 *   Nepovinne filtry
 *
 *   level - logovaci hladina je v rozmezi 1 - 6
 *    - Fatal = 1
 *    - Error = 2
 *    - Warn = 3
 *    - Info = 4
 *    - Debug = 5
 *    - Trace = 6
 *   date__lt - datum do
 *
 *   date__gt - datum od
 * tags:
 *   - docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           type: array
 *           items:
 *             $ref: '#/components/schemas/JobLog'
 *     description: ''
 * ```
 */
export const docsImportLogsListOperation = ({ id, ...rest }: DocsImportLogsListQuery) =>
  ({
    method: 'GET',
    path: `/dmx-server/docs/${id}/import_logs/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'GET';
    path: string & { _templateUrl: '/dmx-server/docs/{id}/import_logs/' };
  };

/**
 * GET /dmx-server/docs/{id}/import_logs/
 *
 * ```yaml
 * operationId: docs_import_logs_list
 * description: >-
 *   Slouží jako základ pro vytváření ViewSets pro zobrazení logů nad konkrétními
 *   objekty, např.
 *
 *   nad objednávkami, kontrolami.
 *
 *
 *   Nepovinne filtry
 *
 *   level - logovaci hladina je v rozmezi 1 - 6
 *    - Fatal = 1
 *    - Error = 2
 *    - Warn = 3
 *    - Info = 4
 *    - Debug = 5
 *    - Trace = 6
 *   date__lt - datum do
 *
 *   date__gt - datum od
 * tags:
 *   - docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           type: array
 *           items:
 *             $ref: '#/components/schemas/JobLog'
 *     description: ''
 * ```
 */
export const docsImportLogsList = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: DocsImportLogsListQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<JobLogResponse[]>> => {
  const operation = docsImportLogsListOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'GET',
    request,
    onUploadProgress,
    cancelToken,
  );
};

/**
 * GET /dmx-server/docs/{id}/import_logs/
 */
export const useDocsImportLogsListResource = (
  query: DocsImportLogsListQuery | null,
  useCached?: boolean,
): UseResource<DocsImportLogsListResponse> => {
  return useResource<DocsImportLogsListResponse>({
    path: query === null ? null : docsImportLogsListOperation(query).path,
    apiUrl: globalThis.DMX_CONFIG.server,
    useCached,
  });
};
